export const view03ImageOptions = {
  angle: 'view03',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    CockpitTable: 1,
    SelfTacker: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: 'BathingPlatform'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'SelfTacker'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'CockpitTable',
      dependency: 'Wheel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view03.js